module.exports = __webpack_public_path__ + "img/truck.d326143e.png";